export default "<div class=\"ion-text-center result-container\">\n    <span class=\"result\">&pound;{{ result.total | number : '1.2-2'}}</span>\n</div>";